import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { WebinarProtectedRoute } from '@/components/WebinarProtectedRoute'
import Home from '@/pages/Home'
import Onboarding from '@/pages/Onboarding'
import Status from '@/pages/Status'
import Lookup from '@/pages/Lookup'
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminLogin from '@/pages/admin/Login'
import RequestDetail from '@/pages/admin/RequestDetail'
import QualificationCandidatesList from '@/pages/admin/QualificationCandidatesList'
import QualificationCandidateDetail from '@/pages/admin/QualificationCandidateDetail'
import WebinarAdminLogin from '@/pages/webinar/Login'
import WebinarAdminDashboard from '@/pages/webinar/Dashboard'

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/status/:id" element={<Status />} />
        <Route path="/lookup" element={<Lookup />} />

        {/* Operator routes (hidden path) */}
        <Route path="/ops-portal/login" element={<AdminLogin />} />
        <Route path="/ops-portal" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/ops-portal/requests/:id" element={
          <ProtectedRoute>
            <RequestDetail />
          </ProtectedRoute>
        } />
        <Route path="/ops-portal/qualification-candidates" element={
          <ProtectedRoute>
            <QualificationCandidatesList />
          </ProtectedRoute>
        } />
        <Route path="/ops-portal/qualification-candidates/:id" element={
          <ProtectedRoute>
            <QualificationCandidateDetail />
          </ProtectedRoute>
        } />

        {/* Webinar admin (shared-key auth, accessible to LinkAfric + MAIN) */}
        <Route path="/inscriptions-admin/login" element={<WebinarAdminLogin />} />
        <Route path="/inscriptions-admin" element={
          <WebinarProtectedRoute>
            <WebinarAdminDashboard />
          </WebinarProtectedRoute>
        } />
      </Routes>
      <Toaster />
    </>
  )
}

export default App
